import React from "react";

export default function ContactUs() {
  const sections = [
    {
      title: "ONLINE WEBSITE ORDERS",
      layout: "single", // single column
      contacts: [
        {
          name: "Ms. Komal",
          phone: "+91-9803061407",
          email: "coordinator@tyka.com",
        },
      ],
    },
    {
      title: "MyTEAM - Custom Order Queries\nClubs / Teams / Corporate",
      layout: "double", // side by side
      contacts: [
        {
          name: "Mr. Aiky",
          phone: "+91-9803020407",
          email: "myteam@tyka.com",
        },
        {
          name: "Ms. Juhi",
          phone: "+91-9591955555",
          email: "myteam@tyka.com",
        },
      ],
    },
    {
      title: "CORE\nDealers / Shop Orders related Queries",
      layout: "single",
      contacts: [
        {
          name: "Mr. Baljinder Singh (Head Office)",
          phone: "+91-9803021407",
          email: "sales@tyka.com",
        },
      ],
    },
    {
      title: "For Dealers / Distribution network",
      layout: "single",
      contacts: [
        {
          name: "",
          phone: "+91-9888167407",
          email: "sales.marketing@tyka.com",
        },
        {
          name: "Mr. Abhishek Kumar",
          phone: "+91-9982854407, 9115117407",
          email: "sales.ncr@tyka.com",
          extra: "(UP, BIHAR, JHARKHAND, MP, CG, DELHI, RJ)",
        },
      ],
    },
    {
      title: "TENDER / GEM related Queries",
      layout: "single",
      contacts: [
        {
          name: "Mr. Paramjit Millu",
          phone: "+91-9803050407",
          email: "sales.tender@tyka.com",
        },
        {
          name: "Mr. Akky",
          phone: "+91-9803020407",
        },
      ],
    },
    {
      title: "TYKA Head Office",
      layout: "single",
      contacts: [
        {
          name: "",
          phone: "+91-9888167407",
        },
      ],
    },
  ];

  return (
    <div className="max-w-4xl mx-auto text-center p-6">
      <h2 className="text-2xl font-bold mb-2">CONTACT US</h2>
      <p className="mb-6 text-black-700">
        Working Hours (Mon - Sat) 10:00 am to 06:00 pm
      </p>

      {sections.map((section, idx) => (
        <div key={idx}>
          <hr className="my-6 border-gray-400" />
          <div className="mb-6">
            <h3 className="text-lg font-bold whitespace-pre-line">
              {section.title}
            </h3>

            {/* Single-column (stacked) or double-column (side by side) */}
            <div
              className={
                section.layout === "double"
                  ? "grid grid-cols-2 gap-6 mt-6"
                  : "mt-6 space-y-4"
              }
            >
              {section.contacts.map((c, i) => (
                <div key={i}>
                  {c.name && <p className="font-medium">{c.name}</p>}
                  <p className="text-sm text-black-800">
                    {c.phone && `Call: ${c.phone}`}
                    {c.email && ` Email: ${c.email}`}
                  </p>
                  {c.extra && (
                    <p className="text-s text-black-600 mt-1">{c.extra}</p>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
